import { useContext, useEffect, useState } from 'react';
import { Form } from 'antd';
import moment from 'moment/moment';
import { CreateBookingFormContext, formActions } from '../CreateBookingForm.context';

const useSelectDateHook = () => {
  const { formState, dispatch } = useContext(CreateBookingFormContext);
  const [form] = Form.useForm();
  const [state, setState] = useState({
    startDate: null,
    endDate: null,
    form,
  });

  useEffect(() => {
    actions.initializeState();
  }, [formState]);

  const actions = {
    initializeState: () => {
      const { bookingDates } = formState;
      if (bookingDates) {
        const { startDate, endDate } = bookingDates;
        form.setFieldsValue({ startDate, endDate });
        updateState({ startDate, endDate });
      } else {
        const today = moment().startOf('day');
        const tomorrow = moment().add(1, 'day').startOf('day');
        form.setFieldsValue({ startDate: today, endDate: tomorrow });
        updateState({ startDate: today, endDate: tomorrow });
      }
    },
    startDateChange: value => {
      form.setFieldsValue({ startDate: value, endDate: null });
      updateState({ startDate: value, endDate: null });
    },
    endDateChange: value => {
      updateState({ endDate: value });
    },
    disableStartDate: current => {
      return current && current < moment().subtract(1, 'days').startOf('day');
    },
    disableEndDate: current => {
      return current <= state.startDate?.endOf('day');
    },
    saveBookingDates: () => {
      dispatch({
        type: formActions.SET_DATES,
        payload: { startDate: state.startDate, endDate: state.endDate },
      });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
};

export default useSelectDateHook;
